import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { FwButtonModule, FwLayoutsModule } from '@flywheel-io/vision';

@Component({
  selector: 'app-error-404',
  imports: [
    FwLayoutsModule,
    FwButtonModule,
  ],
  template: `
    <fw-layout-context
      title="404 Error"
      icon="search-loop"
      iconColor="danger"
      description="The page you are looking for does not exist."
    >
      <fw-button (click)="location.back()" variant="outline">Go back</fw-button>
    </fw-layout-context>
  `,
  styles: [`
    :host {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
    }
  `],
  standalone: true,
})
export class Error404Component {
  constructor(public location: Location) {}
}
